import { ReactNode } from 'react';

import { DrawerHeader as BaseDrawerHeader, Heading } from '@growtherapy/sprout-ui';

type DrawerHeaderProps = Omit<Parameters<typeof BaseDrawerHeader>[0], 'children'>;
type HeadingProps = Omit<Parameters<typeof Heading>[0], 'children'>;

export function DrawerHeader({
  children,
  drawerHeaderProps,
  headingProps,
}: {
  children: ReactNode;
  drawerHeaderProps?: DrawerHeaderProps;
  headingProps?: HeadingProps;
}) {
  return (
    <BaseDrawerHeader {...drawerHeaderProps}>
      <Heading as='h2' {...headingProps}>
        {children}
      </Heading>
    </BaseDrawerHeader>
  );
}
